import "./styles.scss";

import * as React from "react";
import {
    Button,
    Modal,
    ModalBody,
    ModalHeader,
    ModalTitle,
} from "react-bootstrap";

export const LightBox: React.FC<{
    children: React.ReactNode;
    onClose: () => void;
    show: boolean;
    title?: string;
}> = (props) => {
    return (
        <Modal centered show={props.show} size={"lg"}>
            <ModalHeader>
                <ModalTitle>{props.title}</ModalTitle>
                <Button onClick={props.onClose} className={"btn-close"} />
            </ModalHeader>
            <ModalBody>{props.children}</ModalBody>
        </Modal>
    );
};
